import React from 'react';

import { HeaderStyles } from '../../../spacesPlatform/components/header/HeaderStyles';

export module ProfilePictureStyles {

  export module Colors {
    export const DefaultFillColor: string = HeaderStyles.HeaderBackgroundColor;
    export const SpecialFillColor: string = 'white';
  }

  export module Sizes {
    export const LargeIconSize: number = 88;
    export const MediumIconSize: number = 60;
    export const SmallIconSize: number = 45;
    export const UserlIconSize: number = 36;
    export const ExtraSmallIconSize: number = 32;
  }

  export module FontSizes {
    export const LargeIconFontSize: number = 43;
    export const MediumIconFontSize: number = 26;
    export const SmallIconFontSize: number = 21;
    export const ExtraSmallIconFontSize: number = 14;
  }

  export module Layout {
    export const CenterSingleChild: React.CSSProperties = {
      width: '100%',
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-around'
    };

    export const UserNameWithProfilePictureCellWrapperStyle: React.CSSProperties = {
      display: 'flex',
      justifyContent: 'flex-start',
      flexWrap: 'nowrap',
      alignItems: 'center'
    };

    export const UserNameWithProfilePictureCellChildStyle: React.CSSProperties = {
      flex: '0 0 auto',
      marginRight: 10
    };

    export const UserNameWithProfilePictureCellChildDisplayNameStyle: React.CSSProperties = {
      flex: '0 1 auto',
      marginRight: 10,
      overflow: 'hidden'
    };

    export const GroupNameWithProfilePictureCellWrapperStyle: React.CSSProperties = {
      display: 'flex',
      justifyContent: 'flex-start',
      flexWrap: 'nowrap',
      alignItems: 'center'
    };

    export const GroupNameWithProfilePictureCellChildStyle: React.CSSProperties = {
      flex: '0 0 auto',
      marginRight: 10
    };

    export const GroupNameWithProfilePictureCellChildDisplayNameStyle: React.CSSProperties = {
      flex: '0 1 auto',
      marginRight: 10,
      overflow: 'hidden'
    };
  }

  export module TextSelect {
    export const DisAbleUserSelect: React.CSSProperties = {
      'WebkitUserSelect': 'none',
      'MozUserSelect': 'none',
      'msUserSelect': 'none',
      userSelect: 'none'
    };
  }
}
